// Node-chrome tokens shared with the flowchart (and any graph widget) live in
// Cmarkdowngraphcontrols; re-exported here so existing mindmap/treemap/timeline
// imports of these names keep working unchanged.
export {
  NODE_FILL,
  NODE_TEXT,
  HEXAGON_CLIP_PATH,
  DIMMED_OPACITY,
  TRANSITION_DURATION,
} from '../Cmarkdowngraphcontrols/graph-node-frame-constants';

export const DEPTH_COLORS = [
  '#66FEC1',
  '#5B9EFF',
  '#A78BFA',
  '#F29F57',
  '#FF7EB3',
  '#45E0C4',
  '#FDCB6E',
] as const;

export const NODE_MIN_WIDTH = 100;
export const NODE_BASE_HEIGHT = 40;
export const NODE_HORIZONTAL_PADDING = 14;
export const ROOT_NODE_HORIZONTAL_PADDING = 28;
export const NODE_TEXT_CHAR_WIDTH = 8;
export const ROOT_NODE_MIN_WIDTH = 140;
export const ROOT_NODE_HEIGHT = 56;

export const DAGRE_NODESEP = 36;
export const DAGRE_RANKSEP = 80;
export const CONTAINER_HEIGHT = 480;

export const ORBIT_RADIUS = 28;
export const ORBIT_DOT_SIZE = 6;
export const ORBIT_MAX_DOTS = 6;
export const ORBIT_ANIMATION_DURATION_SECONDS = 12;

export const FIT_VIEW_DURATION = 500;
export const FIT_VIEW_PADDING = 0.3;
